import React from "react";
import { useNavigate } from "react-router-dom";
import "./not-found-page.css";

function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="nf-shell">
      <span className="nf-code">404</span>
      <h1 className="nf-title">Page not found</h1>
      <p className="nf-sub">The page you're looking for doesn't exist.</p>
      <button className="nf-btn" onClick={() => navigate("/", { replace: true })}>
        Go to login
      </button>
    </div>
  );
}

export default NotFoundPage;
